import { render, staticRenderFns } from "./course-form.vue?vue&type=template&id=69491503&scoped=true&"
import script from "./course-form.vue?vue&type=script&lang=js&"
export * from "./course-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69491503",
  null
  
)

export default component.exports